type Data = ReadonlyArray<{ processing: boolean; versions?: Data }>;

export function shareVisualsProcessing(shareVisualData: Data): boolean {
	return shareVisualData.some((shareVisual) => {
		if (shareVisual.processing) return true;

		if (shareVisual.versions) return shareVisualsProcessing(shareVisual.versions);

		return false;
	});
}
